import { Component } from '@angular/core';
import { membersuiteInvoiceLineItemEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'MemberSuite: Invoice Line Items') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-membersuiteinvoicelineitem-form',
    templateUrl: './membersuiteinvoicelineitem.form.component.html'
})
export class membersuiteInvoiceLineItemFormComponent extends BaseFormComponent {
    public record!: membersuiteInvoiceLineItemEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

